import { CellphoneBasicIcon } from './CellphoneBasicIcon';

/**
 * author: Simran
 * id E22A55C0-983F-499E-8B43-4A66DB278B4E
 * name cellphone-basic
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-basic.svg
 * tags
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const MobilePhoneBasicIcon = CellphoneBasicIcon;
export default MobilePhoneBasicIcon